module.exports = __webpack_public_path__ + "static/media/fireworks.e37e4d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fireworks.png
// module id = 5828
// module chunks = 0